export default __webpack_public_path__ + "static/media/DTGO_Logo_mini.be06e0e5.png";